import { Badge } from '@/components/ui/badge';
import type { FC, PropsWithChildren } from 'react';

export const DefaultBadge: FC<PropsWithChildren> = ({ children }) => <Badge variant="default">{children}</Badge>;

export const SuccessBadge: FC<PropsWithChildren> = ({ children }) => (
    <Badge variant="outline" className="text-green-700 border-green-700 bg-background">
        {children}
    </Badge>
);

export const InfoBadge: FC<PropsWithChildren> = ({ children }) => (
    <Badge variant="outline" className="text-blue-700 border-blue-700 bg-background">
        {children}
    </Badge>
);

export const WarningBadge: FC<PropsWithChildren> = ({ children }) => (
    <Badge variant="outline" className="text-amber-700 border-amber-700 bg-background">
        {children}
    </Badge>
);

export const AiBadge: FC<{ full?: boolean; className?: string }> = ({ full, className }) => (
    <Badge className={`bg-violet-600 text-white border-violet-600 hover:bg-violet-600 ${className ?? ''}`}>
        {full ? 'AI-Created Type' : 'AI'}
    </Badge>
);

export const PublishedBadge = () => <SuccessBadge>published</SuccessBadge>;

export const DraftBadge = () => <InfoBadge>draft</InfoBadge>;

export const PreviewBadge = () => <WarningBadge>preview</WarningBadge>;
